import React from 'react';

import { Button, Flex, Icon, Link, Text } from '@chakra-ui/react';
import { File } from '@phosphor-icons/react';
import PropTypes from 'prop-types';

import { Alert } from '@firehydrant/design-system';
import OrgRouteLink from 'components/common/OrgRouteLink';

export const NotificationPolicyComplianceAlert = ({
  onMatchAndUpdateAll,
  hasNonCompliance,
  isLoading = false,
}) => {
  if (!hasNonCompliance) return null;

  return (
    <Alert variant="alert" my="4">
      <Flex direction="column" flex="1">
        <Text
          textStyle="heading3"
          mb="1"
          color="content.feedback.error.primary"
        >
          Update your notification preferences?
        </Text>
        <Text textStyle="body1" color="content.feedback.error.secondary" mb="3">
          We recommend reviewing your notification preferences to align with the
          organization&apos;s policy.
        </Text>

        <Flex
          direction={{ base: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems={{ base: 'stretch', md: 'center' }}
          gap={{ base: '3', md: '0' }}
        >
          <Button
            size={{ base: 'md', md: 'sm' }}
            width={{ base: '100%', md: 'auto' }}
            onClick={onMatchAndUpdateAll}
            isLoading={isLoading}
            loadingText="Updating..."
            flexShrink={0}
          >
            Match & update all
          </Button>
        </Flex>
      </Flex>
    </Alert>
  );
};

NotificationPolicyComplianceAlert.propTypes = {
  onMatchAndUpdateAll: PropTypes.func.isRequired,
  onManualUpdate: PropTypes.func.isRequired,
  hasNonCompliance: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
};
